import { useEffect, useMemo } from "react";
import { useRawTable } from "../../hooks";

export default function Module_BoneMuscleCare_VillageHealthInsuranceReferralsCompletionRate({
  moduleTitle = "",
  moduleData = {},
  apiData = [],
}) {
  const moduleDataTemp = useMemo(
    () => ({
      ...moduleData,
      columns: [
        {
          key: "符合轉介",
          field: "符合轉介",
          header: "符合轉介",
        },
        ...(moduleData.columns || [])
          .filter((item) => item.key)
          .map((item) => ({ ...item, header: `已完成轉介\n(${item.header})` })),
        {
          key: "完成率",
          field: "完成率",
          header: "完成率",
        },
      ],
    }),
    [moduleData]
  );
  const { setTbData, renderTable } = useRawTable({
    setting: moduleDataTemp,
    nullTransfer: "-",
  });

  useEffect(() => {
    if (!apiData) return;

    setTbData({
      raw: apiData.map((item) => ({
        ...item,
        符合轉介: moduleData.columns.reduce(
          (pre, cur) => (pre += item[cur.key] ?? 0),
          0
        ),
        完成率: `${
          Math.round(
            (moduleData.columns
              .filter((item) => item.key)
              .reduce((pre, cur) => (pre += item[cur.key] ?? 0), 0) /
              moduleData.columns.reduce(
                (pre, cur) => (pre += item[cur.key] ?? 0),
                0
              )) *
              10000
          ) / 100
        }%`,
      })),
      format: null,
      export: null,
    });
  }, [apiData]);

  return (
    <>
      {renderTable({
        moduleTitle: moduleData.label,
      })}
    </>
  );
}
